import axios from "./AxiosService";
// Import encrypt and decrypt functions from crypto helper
import { encrypt, decrypt } from "../../src/helpers/ICryptoHelper";

// API endpoint for bank detail operations
const endpoint = "MemberBankDetail";
const headers = {
  headers: {
    "Content-Type": "application/json"
  }
};

export default class MemberBankService {
  
  // Fetch existing bank details for a member by membership number
  GetMemberBankDetails(membershipNumber) {
    return axios
      .get(
        endpoint,
        {
          params: { membershipNumber: membershipNumber }
        },
        headers
      )
      .then((response) => {
        return response.data;
      });
  }

  // Update member bank details with encrypted sensitive fields to prevent IDOR attack
  UpdateMemberBankDetails(membershipNumber, bankObj) {

    // Retrieve encryption key from environment variable
    const sKey = process.env.REACT_APP_BankEncryptionKey_API_KEY;

    // Encrypt all sensitive bank fields before sending to API
    const Bank = {
      SortCode: encrypt(bankObj.sortCode, sKey),
      AccountNumber: encrypt(bankObj.AccountNo, sKey),
      AccountHolderName: bankObj.AccountName,
      ClientId: encrypt(bankObj?.ClientId, sKey),
      MembershipNumber: encrypt(membershipNumber, sKey),
      Operation: bankObj?.Operation,
    };

    return axios
      .post(
        endpoint,
        Bank,
        headers
      )
      .then((response) => {
        // Extract bank detail from responses
        const data = response.data.MemberBankDetail;

        // Decrypt sensitive fields returned from API before storing in state
        const decodedBank = {
          ...data,
          AccountNumber: data.AccountNumber ? decrypt(data.AccountNumber, sKey) : null,
          ClientId: data.ClientId ? decrypt(data.ClientId, sKey) : null,
          MembershipNumber: data.MembershipNumber ? decrypt(data.MembershipNumber, sKey) : null,
          SortCode: data.SortCode ? decrypt(data.SortCode, sKey) : null,
        };

        // Return full response with decrypted bank details
        const decodedResponse = {
          ...response.data,
          MemberBankDetail: decodedBank
        };
        return decodedResponse;
      });
  }

  // Delete member bank details - encrypt clientID before sending to prevent IDOR attack
  DeleteMemberBankDetails(membershipNumber, clientId) {

    // Retrieve encryption key from environment variable
    const sKey = process.env.REACT_APP_BankEncryptionKey_API_KEY;

    // Encrypt clientID before passing as delete parameter
    clientId = encrypt(clientId , sKey);

    return axios
      .delete(endpoint, { params: { membershipNumber, clientId} }, headers)
      .then((response) => {
        return response.data;
      });
  }
}
